import { Component, Input, Output, EventEmitter} from '@angular/core';


/**
   * Logger Factory
  
*/

@Component({
  selector: 'ute-delete-drawer',
  templateUrl: 'ute-delete-drawer.component.html'
})

export class UteDeleteDrawer {
  @Input()  isDrawerOpen: boolean;
  @Input()  cancel: boolean = false;
  @Input()  cancelLabel: string;
  @Input()  action: string;
  @Input()  actionLabel: string;
  @Input()  icon: string;
  @Input()  title: string;
  @Input()  description: string;

  @Output() isDrawerOpenChange = new EventEmitter;
  @Output() onClickAction = new EventEmitter;
  @Output() onChangePrivacy = new EventEmitter;

  
  constructor() {}

  ionViewDidLoad() {}
  
  onChangeDrawer(event){
    this.isDrawerOpenChange.emit(false);
  }
  onSubmitAction(event){
    this.onClickAction.emit(event);
  }



}


// WEBPACK FOOTER //
// ./src/app/user/components/ute-delete-drawer/ute-delete-drawer.component.ts